import {
  CheckIcon,
  ClearIcon,
  DoneAllIcon,
  RemoveIcon,
  SearchIcon,
} from "icons";
import { colors } from "theme/palette";

import { EFieldStatus } from "entities/Field/constants";

export interface IFieldStatusIcon {
  status: EFieldStatus;
  sx?: React.CSSProperties;
}

const FieldStatusIcon = ({ status, sx }: IFieldStatusIcon) => {
  switch (status) {
    case EFieldStatus.NOT_DONE:
      return (
        <RemoveIcon
          sx={{
            color: colors.white,
            height: "20px",
            width: "20px",
            padding: 0.25,
            backgroundColor: colors.white,
            border: `2px solid ${colors.blue60}`,
            borderRadius: "2px",
            ...sx,
          }}
          data-testid="not-done-status-icon"
        />
      );
    case EFieldStatus.DONE:
      return (
        <CheckIcon
          sx={{
            color: colors.blue100,
            height: "20px",
            width: "20px",
            padding: 0.25,
            backgroundColor: colors.white,
            border: `2px solid ${colors.blue100}`,
            borderRadius: "2px",
            ...sx,
          }}
          data-testid="done-status-icon"
        />
      );
    case EFieldStatus.IN_REVIEW:
      return (
        <SearchIcon
          sx={{
            color: colors.white,
            height: "20px",
            width: "20px",
            padding: 0.25,
            backgroundColor: colors.blue80,
            borderRadius: "2px",
            ...sx,
          }}
          data-testid="in-review-status-icon"
        />
      );
    case EFieldStatus.SATISFIED:
      return (
        <DoneAllIcon
          sx={{
            color: colors.white,
            height: "20px",
            width: "20px",
            padding: 0.25,
            backgroundColor: colors.blue120,
            borderRadius: "2px",
            ...sx,
          }}
          data-testid="satisfied-status-icon"
        />
      );
    case EFieldStatus.NA:
      return (
        <ClearIcon
          sx={{
            color: colors.gray40,
            height: "20px",
            width: "20px",
            padding: 0.25,
            backgroundColor: colors.white,
            border: `2px solid ${colors.gray40}`,
            borderRadius: "2px",
            ...sx,
          }}
          data-testid="na-status-icon"
        />
      );
  }
};

export default FieldStatusIcon;
